import {shortenEnv} from "../../Const";

export const PHARM_GEN_BUCKET_NAME = `${shortenEnv}-pharm-gen-aggregation-output-graph-image`

export const pharmGenAggregationApiConsts = {
    API_NAME: "pharm-gen-aggregation", // This name needs to be the same as the name of the API in the App.tsx file
    API_PATH: {
        AGGREGATED_VISUALIZATION: "/aggregated-visualization",
        MENU_OPTIONS: "/menu-options"
    },
}